import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Loader from "components/Atoms/SharedComponents/Loader/Loader";

import dayjs from "dayjs";
import CustomerComplaintsTemplate from "../../templates/complaints/customerComplaints";
import {
  getCustomerComplaintsDetailsRequest,
  getCustomerComplaintsRequest,
  updateCustomerComplaintsRequest,
} from "../../services/modules/complaints/customerComplaints";
import { toast } from "react-toastify";
import ComplaintStatus from "../../components/Atoms/SharedComponents/Complaints/complaintsStatus";

function CustomerComplaintsPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const type = searchParams.get("type");

  const list = useSelector(
    (state) => state.customerComplaints.customerComplaints,
  );
  const count = useSelector((state) => state.customerComplaints.count);
  const details = useSelector(
    (state) => state.customerComplaints.customerComplaint,
  );
  const load = useSelector((state) => state.customerComplaints.load);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [page, setPage] = useState(1);
  const [filterObj, setFilterObj] = useState(null);

  const handlePageChange = (page) => {
    setPage(page);
    setFilterObj((prev) => {
      return { ...prev, page_number: page };
    });
  };

  const getDetails = async () => {
    dispatch(getCustomerComplaintsDetailsRequest({ id: id }));
  };

  const getList = async (filterObj) => {
    const requestData = {
      params: {
        page_size: 10,
        page_number: 1,
        keyword: "",
        sort_by: "id",
        ...filterObj,
      },
    };
    dispatch(getCustomerComplaintsRequest(requestData));
  };

  const handleStatus = () => {
    const requestData = {
      body: {
        order_complaint: {
          status: details?.status === "closed" ? "open" : "closed",
        },
      },
      action: () => {
        details?.status === "open"
          ? toast.success(
              t("complaints.success_resolved", {
                status: t("complaints.resolved"),
              }),
            )
          : toast.success(
              t("complaints.success_resolved", {
                status: t("complaints.unresolved"),
              }),
            );
        navigate("/customer-complaints");
      },
    };

    dispatch(updateCustomerComplaintsRequest({ ...requestData, id }));
  };
  // mappedData use for create custom cell to concat multi values or navigate button
  const mappedData = list?.map((data, index) => {
    return {
      ...data,
      // button: <Button variant="outline">test</Button>,
      status: <ComplaintStatus data={data} />,
      order_id: "#" + data?.order_id,
      created_at: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
    };
  });

  const rowData = (data) => {
    setSelectedRow(data);
  };

  const breadcrumbs = [
    {
      active: true,
      path: "/",
      title: t("common.home"),
    },
    {
      active: !type ? false : true,
      path: "/customer-Complaints",
      title: t("complaints.customer_complaints_title"),
    },
    type && {
      active: false,
      title:
        type === "details"
          ? t("complaints.details_title")
          : id
            ? t("complaints.details_title")
            : t("complaints.details_title"),
    },
  ];
  const handelSubmit = (data, formik) => {};

  const filterList = [
    {
      type: "search",
      placeholder: t("complaints.search_by_order_id"),
      onChange: (value) =>
        setFilterObj((s) => {
          return { ...s, keyword: value?.trim(), page_number: 1 };
        }),
      setFilterObj,
    },
    {
      type: "filter",
      placeholder: t("complaints.status"),
      onChange: (value) => {
        console.log(value);
        setFilterObj((s) => {
          return { ...s, status: value?.value, page_number: 1 };
        });
      },
      // options: [{ name: "Super admin", id: "super admin" }],
      options: [
        { id: "closed", name: t("complaints.resolved") },
        { id: "open", name: t("complaints.not_resolved") },
      ],
    },
  ];

  const handleDelete = () => {};

  //list of actions to be displayed when clicked in the 3 dots
  const actionsList = ({ index, data }) => {
    return [
      {
        condition: () => {
          return true;
        },
        click: () => {
          navigate(`?type=details&id=${data?.id}`);
        },
        text: t("common.view"),
      },
    ];
  };

  //if you need more buttons in the header beside the add button
  const headerChildren = <></>;

  //if more modals needed, pass them to the modalComponents as below
  const modalComponents = [];

  //listing all tags
  useEffect(() => {
    if (filterObj) getList(filterObj);
  }, [filterObj]);

  //details of a single tag
  useEffect(() => {
    if (id) getDetails();
  }, [id]);

  return (
    <>
      <Loader open={load?.loading && load?.type === "list"} />
      <CustomerComplaintsTemplate
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        data={mappedData}
        count={count}
        paginationPage={page}
        handlePageChange={handlePageChange}
        rowData={rowData}
        details={details}
        breadcrumbs={breadcrumbs}
        filterList={filterList}
        handelSubmit={handelSubmit}
        actionsList={actionsList}
        headerChildren={headerChildren}
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        handleDeleteRequest={handleDelete}
        modalComponents={modalComponents}
        confirmBtnTitle={
          details?.status === "open"
            ? t("complaints.resolved")
            : t("complaints.unresolved")
        }
        color="black"
        handleConfirmation={handleStatus}
      />
    </>
  );
}

export default CustomerComplaintsPage;
